import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

export type ErrorModalKind = 'session' | 'connection' | 'access' | 'validation' | 'error';

export interface ErrorModalData {
  title?: string;
  message?: string;
  kind?: ErrorModalKind;
  status?: number;
}

@Component({
  selector: 'app-error-handle-component',
  standalone: true,
  templateUrl: './error-handle-component.html',
  styleUrls: ['./error-handle-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorHandleComponent {
  private readonly modalRef = inject(NzModalRef);
  private readonly data = inject<ErrorModalData>(NZ_MODAL_DATA);

  readonly kind: ErrorModalKind = this.data?.kind ?? 'error';
  readonly title = this.data?.title?.trim() || 'Something went wrong';
  readonly message = this.data?.message?.trim() || 'Please try again in a moment.';
  readonly status = this.data?.status;
  readonly dismissible = this.kind !== 'session';

  readonly label: string = {
    session: 'ACCOUNT SECURITY',
    connection: 'CONNECTION ALERT',
    access: 'ACCESS NOTICE',
    validation: 'ACTION REQUIRED',
    error: 'SYSTEM NOTICE',
  }[this.kind];

  readonly actionLabel = this.kind === 'session' ? 'Go to sign in' : 'Got it';

  close(): void {
    this.modalRef.close();
  }
}
